export const FlagsTypes = [
  'AE',
  'AN',
  'AU',
  'BA',
  'BD',
  'BE',
  'BR',
  'BS',
  'CA',
  'CL',
  'CN',
  'CO',
  'CR',
  'DE',
  'DO',
  'EC',
  'EG',
  'ES',
  'FR',
  'GB',
  'GT',
  'HK',
  'HN',
  'ID',
  'IE',
  'IL',
  'IN',
  'IT',
  'JP',
  'KH',
  'KR',
  'LA',
  'LK',
  'MX',
  'MY',
  'NL',
  'NO',
  'NZ',
  'PA',
  'PE',
  'PH',
  'PK',
  'PL',
  'PT',
  'RO',
  'SA',
  'SE',
  'SG',
  'SV',
  'TH',
  'TR',
  'TW',
  'UK',
  'UM',
  'US',
  'VN',
  'ZA',
] as const;

export const PLACEHOLDER_FLAG = 'PLACEHOLDER';
